import { Show } from "solid-js";

type HeaderProps = {
  brandName: string;
  discountPercentage: number;
  showShoppingVoucher: boolean;
  showPercOff: boolean;
};

export function BrandTitle(props: HeaderProps) {
  return (
    <div class="w-full">
      <Show
        when={props.discountPercentage > 0}
        fallback={
          <p>
            <span class="text-h3 text-textDark lg:text-h2">
              {props.brandName} card{" "}
            </span>
          </p>
        }
      >
        <p>
          <span class="text-h3 text-textDark lg:text-h2">
            {props.brandName} gift card{" "}
            {props.showShoppingVoucher ? "(shopping voucher)" : ""}
            <Show when={props.showPercOff}>at</Show>
          </span>
          <Show when={props.showPercOff}>
            <span class="text-h3 text-successDark lg:text-h2">
              {" "}
              {props.discountPercentage}% off
            </span>
          </Show>
        </p>
      </Show>
    </div>
  );
}
